import {useEffect, useState} from 'react';
import {useFormContext} from 'react-hook-form';

// hooks/useFormEmpty.ts
const useFormEmpty = (names?: string[]) => {
    const {watch} = useFormContext();
    const [show, setShow] = useState(false);

    const formValues = names !== undefined ? watch(names) : watch();
    useEffect(() => {
        setShow(Object.values(formValues).some((value) => !!value));
    }, [formValues]);

    return show;
};

export default useFormEmpty;
